import { Navigate } from 'react-router-dom';
import { useAuth } from '../store/AuthContext';
import { JSX } from 'react';
import LoadingSpinner from '../components/Loading/LoadingSpinner';

type ProtectedRouteProps = {
  children: JSX.Element;
  /**
   * Permission(s) the screen needs. The user must hold at least one of them.
   * Omit to only require a signed-in user.
   */
  permission?: string | string[];
};

const ProtectedRoute = ({ children, permission }: ProtectedRouteProps) => {
  const { user, loading, hasAnyPermission } = useAuth();

  if (loading) return <div><LoadingSpinner /></div>;
  if (!user) return <Navigate to="/login" />;

  if (permission) {
    const required = Array.isArray(permission) ? permission : [permission];
    if (!hasAnyPermission(...required)) return <Navigate to="/access-denied" replace />;
  }

  return children;
};

export default ProtectedRoute;
